import type { Article as ContentfulArticle } from '@ui/queries/contentfulArticle';
import type { MarketingCampaign } from '@ui/queries/contentfulCampaign';

export type ArticleUiType = MarketingCampaign | ContentfulArticle;

export const isMarketingCampaign = (
  article: ArticleUiType,
): article is MarketingCampaign => Object.hasOwn(article, 'banner');
